<div class="setup-container">
  <!-- Step Section -->
  <div class="step-section">
    <h3 class="step-title">
      <i class="bi bi-bullseye"></i> Select Role
    </h3>
    <div class="dropdown-container" [class.open]="isDropdownOpen">
      <div class="input-wrapper">
        <i class="bi bi-search search-icon"></i>
        <input type="text" class="dropdown-input"
          placeholder="Search and select a role (e.g., Software Trainee...)" [(ngModel)]="searchTerm"
          (focus)="openDropdown()" (input)="filterRoles()" />
      </div>

      <ul class="dropdown-list" *ngIf="isDropdownOpen">


        <li *ngFor="let role of filteredRoles" (click)="selectRole(role)" [class.active]="selectedRole?.id === role.id"
          class="dropdown-item">
          {{ role.title }}
        </li>

        <li class="dropdown-item create-role" (click)="createNewRole()">
          <i class="bi bi-plus-lg"></i> Create New Role
        </li>

        <li *ngIf="filteredRoles.length === 0" class="no-result">
          No roles found
        </li>
      </ul>

      <div *ngIf="loading" class="loading-text">
        <i class="bi bi-arrow-repeat spin"></i> Loading roles...
      </div>
    </div>


  </div>


  <!-- Select Round -->
  <div class="step-section">
    <h3 class="step-title">
      <i class="bi bi-soundwave"></i> Select Interview Round
    </h3>

    <div *ngIf="roundsLoading" class="loading-text">
      <i class="bi bi-arrow-repeat spin"></i> Loading rounds...
    </div>

    <div class="round-grid" *ngIf="!roundsLoading">
      <div class="round-card" *ngFor="let round of rounds"
        [ngClass]="[round.key, selectedRound?.id === round.id ? 'selected' : '',
		!round.is_available_for_user ? 'blurred' : '']" (click)="selectRound(round)">
        <div class="icon">
          <i [class]="round.icon"></i>
        </div>

        <div class="round-content">
          <h4>{{ round.name }}</h4>
          <p>{{ round.description }}</p>

          <div class="selected-status" *ngIf="selectedRound?.id === round.id">
            <span class="dot" [ngClass]="round.key + '-dot'"></span> Selected
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Pro Tip -->
  <div class="pro-tip">
    <div class="tip-header">
      <div class="tip-icon"><i class="bi bi-lightbulb-fill text-warning"></i></div>
      <strong>Pro Tip:</strong>
    </div>
    <p>
      Choose your role and round to get tailored interview questions that match
      real industry standards. Each round focuses on different skills to give you
      comprehensive practice.
    </p>
  </div>
  <div class="action-buttons">
    <p>
      Please select both role and round to continue
    </p>
    <button class="continue-btn" (click)="onContinue()">Continue →</button>
  </div>


</div>
<app-role-create-dailog [show]="showCreateRoleModal" (close)="closeCreateRoleModal()"
  (roleCreated)="handleRoleCreated($event)"></app-role-create-dailog>